/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./downlinksActility.vue?vue&type=template&id=870f05c8&scoped=true"
import script from "./downlinksActility.vue?vue&type=script&lang=js"
export * from "./downlinksActility.vue?vue&type=script&lang=js"
import style0 from "./downlinksActility.vue?vue&type=style&index=0&id=870f05c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870f05c8",
  null
  
)

export default component.exports